const LAST_SELECTED_MARKET_SYMBOL_KEY = 'lastSelectedMarketSymbol'

export const getLastSelectedMarketSymbol = (): string => {
  try {
    return localStorage.getItem(LAST_SELECTED_MARKET_SYMBOL_KEY) ?? ''
  } catch {
    return ''
  }
}

export const setLastSelectedMarketSymbol = (symbol: string) => {
  if (!symbol) return

  try {
    localStorage.setItem(LAST_SELECTED_MARKET_SYMBOL_KEY, symbol)
  } catch {
    // localStorage can be unavailable in private browsing or restricted webviews.
  }
}
